module.exports = __webpack_public_path__ + "static/img/bok1.b0ddc8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/plants/bok/bok1.jpg
// module id = ue5O
// module chunks = 1